import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './qty.html';
import './qty.scss';

const isNumeric = (/** @type {any} */ n) => !Number.isNaN(Number.parseFloat(n)) && Number.isFinite(n);

const qtyConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('qty', {
		title:      'Quantity',
		template,
		children:   false,
		group:      'advanced',
		selectable: true,
		settings:   {
			autofocus:      false,
			disabled:       false,
			input:          true,
			tableView:      true,
			inputType:      'number',
			label:          'Quantity',
			key:            'qty',
			hideLabel:      false,
			placeholder:    '',
			defaultValue:   {
				qty:  null,
				unit: null,
			},
			protected:      false,
			persistent:     true,
			hidden:         false,
			clearOnHide:    true,
			validate:       {
				card: '0-1',
				min:      '',
				max:      '',
				step:     'any',
				integer:  '',
				custom:   '',
			},
			decimalLimit:   0,
			delimiter:      false,
			requireDecimal: false,
			disableUnit:    false,
			hideUnit:       false,
			event:          {
				onChange: null,
			},
			kdata:          {
				submit: true,
			},
		},
		icon:          'fa fa-thermometer-half',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/qty/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/qty/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/qty/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.$watch('component.defaultValue', () => {
				$scope.data[$scope.component.key] = {
					qty: $scope.component.defaultValue.qty,
					unit: $scope.component.defaultValue.unit,
				};
			}, true);
		},
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.maskOptions = {
				padFractionalZeros: $scope.component.requireDecimal,
				scale:              $scope.component.decimalLimit,
			};

			if ($scope.options?.building) {
				return;
			} // FOR-71 - Skip parsing input data.

			// Ensure that values are numbers.
			if ($scope.data && Object.prototype.hasOwnProperty.call($scope.data, $scope.component.key)) {
				$scope.$watch('component.defaultValue', () => {
					if ($scope.data === undefined || $scope.data[$scope.component.key] === undefined) {
						$scope.data[$scope.component.key] = {
							qty:  $scope.component.defaultValue.qty,
							unit: $scope.component.defaultValue.unit,
						};
					}
				}, true);
				if (Array.isArray($scope.data[$scope.component.key])) {
					for (const [index, value] of $scope.data[$scope.component.key].entries()) {
						if (!isNumeric(value.qty)) {
							$scope.data[$scope.component.key][index].qty = Number.parseFloat(value);
						}
					}
				}
				else if (
					$scope.data[$scope.component.key].qty !== undefined
					&& !isNumeric($scope.data[$scope.component.key].qty)
				) {
					$scope.data[$scope.component.key].qty = Number.parseFloat($scope.data[$scope.component.key].qty);
				}
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};

			$scope.isRequired = (
				/** @type {any} */ component,
				/** @type {any[]} */ componentsToRequire,
			) => kformUtils.isRequired(component, componentsToRequire);
		},
	});
};

export default angular.module('app').config(qtyConfig);
